import {useEffect, useState, useRef} from "react";

export const useZoom = () => {
    const frameRef = useRef<HTMLDivElement>(null!);
    const [scale, setScale] = useState(1);
    const [initialDistance, setInitialDistance] = useState(0);
    const [initialScale, setInitialScale] = useState(1);

    const handleTouchStart = (e: React.TouchEvent) => {
         if (e.touches.length === 2) {
            const dx = e.touches[0].clientX - e.touches[1].clientX;
            const dy = e.touches[0].clientY - e.touches[1].clientY;
            setInitialDistance(Math.sqrt(dx * dx + dy * dy));
            setInitialScale(scale);
        }
    };

    useEffect(() => {
    const handleTouchMove = (e: TouchEvent) => {
        if (e.touches.length === 2 && initialDistance > 0) {
            const dx = e.touches[0].clientX - e.touches[1].clientX;
            const dy = e.touches[0].clientY - e.touches[1].clientY;
            const newDistance = Math.sqrt(dx * dx + dy * dy);
            setScale(Math.max(0.5, Math.min(initialScale * (newDistance / initialDistance), 3)));
        }
    };
       
    const handleTouchEnd = () => {
        setInitialDistance(0);
    };
        
        document.addEventListener("touchmove", handleTouchMove);
        document.addEventListener("touchend", handleTouchEnd);
    
        return () => {
            document.removeEventListener("touchmove", handleTouchMove);
            document.removeEventListener("touchend", handleTouchEnd);
        };
        }, [initialDistance, initialScale]);

        useEffect(() => {
        const frameElement = frameRef.current;
        if (!frameElement) return;

        const handleWheel = (e: WheelEvent) => {
            e.preventDefault();
            setScale(prev => Math.max(0.5, Math.min(prev + (e.deltaY < 0 ? 0.05 : -0.05), 3)));
        };

            frameElement.addEventListener("wheel", handleWheel, { passive: false });

        return () => {
            frameElement.removeEventListener("wheel", handleWheel);
        };
    }, []);

        return{
            scale,
            setScale,
            frameRef,
            handleTouchStart,
            initialDistance 
        }
};